//#region Util Imports


import * as _ from 'underscore'
import * as moment from 'moment'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/date_box'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/select_box'
import 'devextreme/ui/text_area'
import 'devextreme/ui/toolbar'

//#endregion

import { CorrespondingActionTypeModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { CreateEditPopupOptions } from '../../common/create-edit-popup/create-edit-popup.directive'
import { CommonHelper } from '../../../helpers/common-helper'
import { i18n } from '../../common/i18n/common.i18n'
import { SelectPopoverMultySelectionSource } from '../select-popover/select-popover.directive'
import { DataValue } from '../../../models/local'
import { LocalizationHelper, ToastHelper } from '../../../helpers'
import { OpActionResult } from '../../../models/custom'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { ActionService } from '../../../services/action'
import { Enums } from '../../../models/common'


//#region Asset Imports

import './select-box-popup.scss'
import * as TEMPLATE from './select-box-popup.tpl.html'

//#endregion

interface SelectBoxPopupScope extends ng.IScope {
    popupId: number

    popupOptions: DevExpress.ui.dxPopupOptions
    popupTitle: string
    popupVisible: boolean
    type: Type

    options: CreateEditPopupOptions
    dictionary: any
    toolbarOptions: DevExpress.ui.dxToolbarOptions

    selectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    items: CorrespondingActionTypeModel[]
    selected: number
    isDescriptionShow: boolean
    descriptionHtml: string

    source: Source

    selectPopoverSource: SelectPopoverSource
    onValueSelected: (id: number) => void
    onValuesSelected: (ids: number[]) => void
    sourceWithPopover: SourcePopover

    textAreaOptions: DevExpress.ui.dxTextAreaOptions
    sourceTextArea: SourceTextArea
    devicesInputId: number

    submitButtonText: string

    sourceDateBox: SourceDateBox
    dateBoxOptions//: DevExpress.ui.dxDateBoxOptions
    selectedDate: any

    selectedDataTypesSource: SelectPopoverMultySelectionSource

    //confirmationPopup
    confirmPopupId: any
    needConfirmPopup: boolean
    onConfirm: () => void
    onCancelConfirm: () => void
}

export interface Source {
    popupTitle: string
    itemsList: any
    selectedValue: number
    submitButtonText: string
    onSubmit(value: number): void
    onHiding(): void
}

export interface SourcePopover {
    popupTitle: string
    selectPopoverSource: SelectPopoverSource
    onSubmit(value: number): void
    onCancel?: () => void
    onSubmitMulty?: (ids: number[]) => void
    onHiding?: () => void
    nothingSelectedMsg?: string
    needConfirmation?: boolean
    allowEmptyValueSubmit?: boolean
}

export interface SelectPopoverSource {
    selectedId: number | string
    dataTypeId: number
    referenceTypeId: number

    dictionaryMethod?: string
    needConfirmation?: boolean
    dataIdSourceModule?: Enums.WebSimaxModule
    groupReferenceType?: Enums.ReferenceType
    groupReferenceValue?: number
}

export interface SourceTextArea {
    popupTitle: string
    onSubmit(values: string)
}

export interface SourceDateBox {
    popupTitle: string
    type: string
    value: any
    minDate?
    maxDate?
    needConfirmation: boolean
    onSubmit: (value) => void
}

enum Type {
    selectBox = 0,
    selectPopoverSingle = 1,
    textArea = 2,
    selectPopoverMulty = 3,
    dateBox = 4
}

export class SelectBoxPopupDirective implements ng.IDirective {
    constructor() { }
    private selectedValue = null
    private selectedIds: any[] = []
    private textArea: DevExpress.ui.dxTextArea
    private customMsg: string = null
    private destinationIds: number[] = []
    private dateBox: DevExpress.ui.dxDateBox
    private previouseSelectedDate: any
    private selectBoxPoupup: DevExpress.ui.dxPopup
    private $sce: ng.ISCEService

    scope = {
        popupId: '=',
        source: '=?'
    }
    restrict = 'E'
    controller = [
        $SCOPE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        '$sce',
        USER_SESSION_SERVICE_NAME,
        (
            $scope: SelectBoxPopupScope,
            $timeout: ng.ITimeoutService,
            $sce: ng.ISCEService,
            userSessionService: UserSessionService,
            actionService: ActionService
        ) => {

            $scope.popupVisible = false
            $scope.popupTitle = ($scope.source) ? $scope.source.popupTitle : i18n('Popup', 'SelectActionRun')
            $scope.submitButtonText = ($scope.source) ? $scope.source.submitButtonText : i18n('Common', 'Run')
            $scope.isDescriptionShow = false

            $scope.popupOptions = {
                bindingOptions: {
                    visible: 'popupVisible',
                    title: 'popupTitle'
                },
                width: 400,
                height: 200,
                showTitle: true,
                closeOnOutsideClick: true,
                onHiding: () => {
                    if ($scope.type == Type.textArea) $scope.$root.$broadcast(EventsNames.CLOSE_TEXTAREA_POPUP)
                    this.selectedValue = null
                    this.selectedIds = []
                    if ($scope.type == Type.selectPopoverMulty) $scope.selectedDataTypesSource = null
                    $scope.type = null
                    this.destinationIds = []
                    $scope.needConfirmPopup = false

                    if ($scope.source != null && _.isFunction($scope.source.onHiding)) {
                        $scope.source.onHiding()
                    }

                    if ($scope.sourceWithPopover != null && _.isFunction($scope.sourceWithPopover.onHiding)) {
                        $scope.sourceWithPopover.onHiding()
                    }
                },
                onInitialized: e => {
                    this.selectBoxPoupup = e.component
                },
            }

            $scope.selectBoxOptions = {
                displayExpr: 'name',
                valueExpr: 'id',
                bindingOptions: {
                    dataSource: 'items',
                    value: 'selected'
                },
                noDataText: i18n('Common', 'NoData'),
                placeholder: i18n('Common', 'Select'),
                onValueChanged: e => {
                    $scope.selected = e.value
                    updateDescription(e.value)
                },
                onInitialized: e => {
                    updateDescription($scope.selected)
                }
            }

            $scope.textAreaOptions = {
                height: 83,
                onInitialized: e => { this.textArea = e.component }
            }

            $scope.toolbarOptions = {
                items: [
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            bindingOptions: {
                                text: 'submitButtonText'
                            },
                            onClick: () => {
                                submit()
                            }
                        }
                    },
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: i18n('Common', 'Cancel'),
                            onClick: () => {
                                $scope.popupVisible = false
                                this.selectedValue = null
                                $scope.type = null

                                if ($scope != null
                                    && $scope.sourceWithPopover != null
                                    && $scope.sourceWithPopover.onCancel != null
                                ) {
                                    $scope.sourceWithPopover.onCancel()
                                }
                            }
                        }
                    }
                ]
            }

            $scope.$on(EventsNames.OPEN_SELECT_BOX_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
                $scope.items = ($scope.source != null && $scope.source.itemsList != null) ? $scope.source.itemsList : _.size(args) > 0 ? args[0] : []
                $scope.popupVisible = true
                $scope.type = Type.selectBox
                $scope.selected = ($scope.source && $scope.source.selectedValue) ? $scope.source.selectedValue : _.size(args) > 1 ? args[1] : null
            })

            $scope.$on(EventsNames.OPEN_SELECT_POPOVER_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
                $scope.popupVisible = true
                $scope.type = Type.selectPopoverSingle
                $scope.sourceWithPopover = args[0]
                $scope.selectPopoverSource = $scope.sourceWithPopover.selectPopoverSource
                this.selectedValue = $scope.selectPopoverSource.selectedId
                $scope.popupTitle = $scope.sourceWithPopover.popupTitle
                $scope.submitButtonText = i18n('Popup', 'Assign')
                this.customMsg = $scope.sourceWithPopover.nothingSelectedMsg
            })

            $scope.$on(EventsNames.OPEN_TEXTAREA_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
                $scope.popupVisible = true
                $scope.type = Type.textArea
                $scope.sourceTextArea = args[0]
                $scope.popupTitle = $scope.sourceTextArea.popupTitle
            })


            $scope.$on(EventsNames.OPEN_SELECT_POPOVER_MULTY_SELECTION_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
                $scope.popupVisible = true
                $scope.type = Type.selectPopoverMulty
                $scope.sourceWithPopover = args[0]
                $scope.selectedDataTypesSource = args[0].selectPopoverSource
                if ($scope.selectedDataTypesSource)
                    this.selectedIds = $scope.selectedDataTypesSource.selectedIds

                $scope.popupTitle = $scope.sourceWithPopover.popupTitle + ' (' + this.selectedIds.length + '/' + $scope.selectedDataTypesSource.staticSource.length + ')'
                $scope.submitButtonText = i18n('Common', 'Apply')

                if ($scope.sourceWithPopover.needConfirmation) {
                    $scope.confirmPopupId = new Date().getTime()
                    $scope.onConfirm = submitConfirmed
                    $timeout(() => { $scope.needConfirmPopup = true })
                }

                this.destinationIds = args[1] || []
            })

            $scope.$on(EventsNames.OPEN_DATEBOX_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
                $scope.popupVisible = true
                $scope.type = Type.dateBox
                $scope.sourceDateBox = args[0]
                $scope.popupTitle = $scope.sourceDateBox.popupTitle
                $scope.submitButtonText = i18n('Common', 'Apply')
                $scope.selectedDate = $scope.sourceDateBox.value
                if ($scope.sourceDateBox.needConfirmation) {
                    $scope.confirmPopupId = new Date().getTime()
                    $scope.onConfirm = submitConfirmed
                    $scope.onCancelConfirm = cancelConfirm
                    $timeout(() => { $scope.needConfirmPopup = true })
                }
                $scope.dateBoxOptions = {
                    type: $scope.sourceDateBox.type,
                    min: $scope.sourceDateBox.minDate,
                    max: $scope.sourceDateBox.maxDate,
                    acceptCustomValue: false,
                    bindingOptions: {
                        value: 'selectedDate'
                    },
                    showClearButton: true,
                    onValueChanged: e => {
                        this.previouseSelectedDate = e.previousValue
                        $scope.selectedDate = e.value
                    },
                    onInitialized: e => { this.dateBox = e.component }
                }
            })

            var submitConfirmed = () => {
                if ($scope.type == Type.selectPopoverMulty) {
                    $scope.sourceWithPopover.onSubmitMulty(this.selectedIds)
                    $scope.popupVisible = false
                } else if ($scope.type == Type.dateBox) {
                    $scope.sourceDateBox.onSubmit($scope.selectedDate)
                    $scope.popupVisible = false
                }

            }

            var cancelConfirm = () => {
                if ($scope.type == Type.dateBox) {
                    $scope.selectedDate = this.previouseSelectedDate
                    this.dateBox.option('value', $scope.selectedDate)
                }
            }

            var submit = () => {
                if ($scope.type == Type.selectPopoverSingle) {
                    if (this.selectedValue != null || ($scope.sourceWithPopover != null && $scope.sourceWithPopover.allowEmptyValueSubmit === true)) {
                        $scope.popupVisible = false
                        $scope.sourceWithPopover.onSubmit(this.selectedValue)
                        $timeout(() => {
                            $scope.sourceWithPopover.selectPopoverSource.selectedId = null
                        }, 500)
                    } else {
                        if (this.customMsg) CommonHelper.openInfoPopup(this.customMsg, 'warning', 2000)
                        else CommonHelper.openInfoPopup(i18n('Common', 'NothingSelected'), 'warning', 2000)
                    }
                } else if ($scope.type == Type.textArea) {
                    $scope.popupVisible = false
                    $scope.sourceTextArea.onSubmit(this.textArea.option('value'))
                } else if ($scope.type == Type.selectPopoverMulty) {
                    if ($scope.sourceWithPopover && $scope.sourceWithPopover.onSubmitMulty) {
                        if (!this.selectedIds || this.selectedIds.length == 0) {
                            CommonHelper.openInfoPopup(i18n('Common', 'NothingSelected'), 'warning', 2000)
                        } else {
                            if ($scope.sourceWithPopover.needConfirmation) {
                                $timeout(() => {
                                    var message: string = ''
                                    var problems = this.selectedIds.map(sel => {
                                        if (sel.name) return sel.name
                                        else return $scope.selectedDataTypesSource.staticSource.filter(item => item.id == sel)[0].name
                                    }).join(', ')
                                    if (this.destinationIds.length == 1) {
                                        message = i18n('Popup', 'AcceptNextProblems') + ': ' + problems
                                    } else if (this.destinationIds.length > 1) {
                                        message = i18n('Popup', 'AcceptNextProblems') + ': ' + problems + ' ' + i18n('Popup', 'For') + ' ' + this.destinationIds.length + ' ' + i18n('Popup', 'Locations_')
                                    }
                                    $scope.needConfirmPopup = true
                                    $timeout(() => {
                                        $scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.confirmPopupId, message)
                                    })
                                })
                            } else {
                                submitConfirmed()
                            }
                        }
                    }
                } else if ($scope.type == Type.dateBox) {
                    if ($scope.sourceDateBox.needConfirmation) {
                        $timeout(() => {
                            var message: string = ''
                            if ($scope.selectedDate)
                                message = i18n('Popup', 'ConfirmPlannedDeliveryDate') + ' <b>' + moment($scope.selectedDate).format(window['simax'].getDateFormat('DATE_FORMAT_MOMENTJS')) + '</b>?'
                            else
                                message = i18n('Popup', 'ConfirmCancelDelivery') + '?'
                            $timeout(() => {
                                $scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.confirmPopupId, message)
                            })
                        })
                    } else {
                        submitConfirmed()
                    }

                    //$scope.popupVisible = false
                    //$scope.sourceDateBox.onSubmit(value)
                } else if (!$scope.source) {
                    if ($scope.selected != null) {
                        const action: CorrespondingActionTypeModel = $scope.items.filter((item: CorrespondingActionTypeModel) => item.id == $scope.selected)[0]
                        if (action != null) {
                            const dataValues: DataValue[] = actionService.getDataValues(action)

                            userSessionService
                                .getDataProvider()
                                .Action
                                .sendAction(action.id, action.referenceValues, action.type, dataValues)
                                .then((result: OpActionResult[]) => {
                                    ToastHelper.showSuccess(LocalizationHelper.getLocalizedText('ActionStarted', { collection: 'Popup' }))
                                })
                                .fail(() => {
                                    ToastHelper.showError(LocalizationHelper.getLocalizedText('ActionRunProblem', { collection: 'Popup' }))
                                })
                                .always(() => {
                                    $scope.popupVisible = false
                                })
                            return
                        }
                    }
                    ToastHelper.showInfo(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NothingSelected))
                }
                else {
                    $scope.popupVisible = false
                    $scope.source.onSubmit($scope.selected)
                }
            }

            $scope.onValueSelected = (id) => {
                this.selectedValue = id
            }

            $scope.onValuesSelected = (ids: any[] = []) => {
                this.selectedIds = ids.map(item => { return item.id })
                $scope.selectedDataTypesSource.selectedIds = this.selectedIds
                $scope.popupTitle = $scope.sourceWithPopover.popupTitle + ' (' + this.selectedIds.length + '/' + $scope.selectedDataTypesSource.staticSource.length + ')'
            }

            let updateDescription = (id: number) => {
                if ($scope.type == Type.selectBox) {
                    const selectedItem = $scope.items != null ? ($scope.items.filter((value: CorrespondingActionTypeModel) => value.id == id)) : null
                    let descriptionItem: string =
                        (selectedItem != null && selectedItem.length == 1 && selectedItem[0]['descr'] != null)
                            ? selectedItem[0]['descr']
                            : null

                    if (descriptionItem != null) {
                        $scope.isDescriptionShow = true
                        $scope.descriptionHtml = $sce.trustAsHtml(descriptionItem)
                        this.selectBoxPoupup.option("height", 600)
                        this.selectBoxPoupup.option("width", 500)
                    } else {
                        $scope.isDescriptionShow = false
                        this.selectBoxPoupup.option("height", 200)
                        this.selectBoxPoupup.option("width", 400)
                    }
                }
            }

        }]
    template = TEMPLATE
    transclude = true
}